import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const getLibraryMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getLibraryMymesAPI'],
  path: '/user-library'
};

export const addMymeToLibraryAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-library/assign'
};

export const removeMymeFromLibraryAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/user-library/:mymeId'
};

export const searchLibraryMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['searchLibraryMymesAPI'],
  path: '/user-library/search'
};

export const markMymeAsOpenedAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-library/:mymeId/mark-as-opened'
};
